
<header *ngFor="let page of pages" class="section" [ngStyle]="{'background-size':'cover','background-image': 'url('+page.background_image+')'}">
			<div class="row" style="">
				<div class="col-md-10 offset-md-1"><h1><span [innerHTML]=page.title></span></h1></div>
				<div class="col-md-10 offset-md-1">
					<h3 *ngIf="page.id!=0" [innerHTML]="page.excerpt"></h3>
					<!-- <a href="#more">
						<div class="arrow-down">&#8681;</div>
					</a> -->
				</div>
			</div>
</header>
